export default __webpack_public_path__ + "static/media/login-03.3972a267.jpg";